import React, { useState, useEffect } from 'react';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';

interface AlertBannerProps {
  message: string;
  severity?: 'error' | 'warning' | 'info' | 'success';
}

const AlertBanner: React.FC<AlertBannerProps> = ({
  message,
  severity = 'error',
}) => {
  const [open, setOpen] = useState(true);

  // Reset open state when the message changes
  useEffect(() => {
    setOpen(true); // Reset to open when a new message is provided
  }, [message]);

  if (!open) return null;

  return (
    <Box sx={{ width: '100%', marginBottom: 2 }}>
      <Alert
        severity={severity}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => setOpen(false)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </Box>
  );
};

export default AlertBanner;
